/* eslint-disable @typescript-eslint/no-magic-numbers */
import LoginBackgroundImage from 'Assets/Images/login-background.webp';
import DialogBox2 from 'components/DialogBox2';
import Splash from 'components/Splash';
import useDialog from 'hooks/util/useDialog';
import CenterValidationDialog, {
  CenterValidationFormData,
} from 'pages/CenterValidation/components/CenterValidationDialog';
import ConfirmationDialog from 'pages/CenterValidation/components/ConfirmationDialog';
import useCenterValidation from 'pages/CenterValidation/hooks/useCenterValidation';
import { type ReactElement } from 'react';

function LoginSlide({ children }: { children: ReactElement }) {
  return (
    <div className="absolute inset-0 animate-fadeIn opacity-0">
      <div
        className="flex h-full w-full items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${LoginBackgroundImage})` }}
      >
        <div className="absolute right-0 z-10 flex h-full w-full animate-splashLogo items-center justify-center rounded-l-[1.5em] bg-neutral-white sm:w-[27em] md:w-[30em] lg:w-[35em] xl:w-[38.4375em]">
          {children}
        </div>
      </div>
    </div>
  );
}

export default function CenterValidation(): ReactElement {
  const { isOpen, openDialog, closeDialog, dialogProperties, onClose } = useDialog();
  const { errors, isSubmitting, onSubmitCenterDetails, onProceed, resetValidation } =
    useCenterValidation();

  const onHandleBack = closeDialog;

  const onSubmitCenterDetailsHelper = (data: CenterValidationFormData) =>
    onSubmitCenterDetails(data, (response) => {
      if (response.status === 200) {
        openDialog(
          <ConfirmationDialog
            validationResponse={response.data}
            onBack={onHandleBack}
            onProceed={(validationResponse) => onProceed(validationResponse, data)}
          />,
        );
      }
    });

  return (
    <div className="h-screen w-screen overflow-hidden">
      <div className="relative h-full w-full">
        <Splash />
        <LoginSlide>
          <CenterValidationDialog
            errors={errors}
            isSubmitting={isSubmitting}
            resetValidation={resetValidation}
            onSubmitCenterDetails={onSubmitCenterDetailsHelper}
          />
        </LoginSlide>
      </div>
      {isOpen && (
        <DialogBox2 open={isOpen} onClose={onClose} styles="" showCloseIcon>
          {dialogProperties.component}
        </DialogBox2>
      )}
    </div>
  );
}
